import { useBottomSheet } from 'shared/src/shared/model/controller-model/model/controller-model';

export const useHotOffersRoutesBottomSheetController = () => {
  const bottomSheet = useBottomSheet();
  const bottomSheetName = 'hot-offers-routes-bottom-sheet';

  return {
    name: bottomSheetName,
    show: (destCityCode: string) => {
      bottomSheet.show(bottomSheetName, { destCityCode });
    },
    hide: () => bottomSheet.hide(bottomSheetName),
    params: () =>
      bottomSheet.getParams(bottomSheetName) as { destCityCode: string },
  };
};
